'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var campaignFilterHistory = function campaignFilterHistory(filterHistory) {
    _classCallCheck(this, campaignFilterHistory);

    return {
        saveCampaignContactFilter: function saveCampaignContactFilter(levelOfInterests, selectedLevelOfInterest) {
            filterHistory.saveFilter({
                investorSubtypes: [],
                levelOfInterests: levelOfInterests.map(function (item) {
                    return {
                        value: item.filterKey,
                        name: item.name,
                        color: item.color,
                        checked: item.apiKey === selectedLevelOfInterest,
                        items: item.items ? item.items.map(function (subitem) {
                            return {
                                value: subitem.filterKey,
                                name: subitem.name,
                                checked: subitem.apiKey === selectedLevelOfInterest,
                                color: subitem.color
                            };
                        }) : null
                    };
                })
            }, 'campaign-contact');
        }
    };
};

exports.default = campaignFilterHistory;


campaignFilterHistory.inject = ['filterHistory'];


/** WEBPACK FOOTER **
 ** ./src/app/services/campaignFilterHistory.js
 **/